import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { trackEvent } from 'analytics/trackFunctions'

import PageWrapper from 'components/PageWrapper'
import PrimaryButton from 'components/primaryButton'

import ErrorIcon from 'assets/icons/ErrorIcon'

const AdvanceError = () => {
  const navigate = useNavigate()

  useEffect(() => {
    trackEvent({ eventName: 'bille_adelantos_error_oferta' })
  }, [])

  return (
    <PageWrapper noTabBar viewSelected='/adelantos'>
      <section className='flex flex-col items-center sm:max-w-[22.5rem] mx-auto mt-24'>
        <ErrorIcon />
        <h1
          data-testid='firstErrMessage'
          className='font-bold text-black text-xl text-center leading-5 mt-8'
        >
          Oops, tu adelanto no pudo ser
          <br />
          completado
        </h1>
        <p
          data-testid='secondErrMessage'
          className='font-medium text-gray-900 text-base mt-2 mb-20'
        >
          Volvé atrás e intentá pedirlo nuevamente.
        </p>
        <PrimaryButton
          buttonText='Volver atrás'
          primaryButtonFunction={() => {
            trackEvent({
              eventName: 'bille_adelantos_boton_error_oferta_reintentar'
            })
            navigate(-1)
          }}
        />
      </section>
    </PageWrapper>
  )
}

export default AdvanceError
